export type TSendTaskMakeAnAppointment = {
  message?: string;
  conversationId: string;
  tags?: string[];
  actorId?: string;
};

export type DiagnosisForm = {
  name: string;
  esbId: string;
};

export type TestForm = {
  name: string;
  id: string;
};

export type Tags = 'billing' | 'clinical' | 'clerical';

export type TNewStatus = {
  assignmentId: string;
  conversationId: string;
  status: AssignmentStatus;
};

export enum Fasting {
  NotProvided = 'NotProvided',
  Fasting = 'Fasting',
  Nonfasting = 'Nonfasting',
}

export enum FastingVisible {
  'NotProvided' = 'Not provided',
  'Fasting' = 'Fasting',
  'Nonfasting' = 'Nonfasting',
}

export enum AssignmentStatus {
  'Incomplete' = 'Incomplete',
  'Completed' = 'Completed',
  'Cancelled' = 'Cancelled',
}

export enum TAssignment {
  MakeAnAppointment = 'MakeAnAppointment',
  RejectionReasonSolving = 'RejectionReasonSolving',
  NoticeOfCriticalValues = 'NoticeOfCriticalValues',
}
